import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

const RadioStep = ({ question, selectedValue, onSelect }) => (
  <RadioGroup
    value={selectedValue}
    onValueChange={onSelect}
    className="space-y-3"
  >
    {question.options.map((option) => (
      <div
        key={option.value}
        className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
          selectedValue === option.value
            ? "border-primary bg-primary/5"
            : "border-border hover:border-primary/50"
        }`}
        onClick={() => onSelect(option.value)}
        data-testid={`option-${option.value}`}
      >
        <RadioGroupItem value={option.value} id={option.value} className="mt-1" />
        <Label htmlFor={option.value} className="cursor-pointer flex-1">
          <span className="font-medium block">{option.label}</span>
          {option.desc && (
            <span className="text-sm text-muted-foreground">{option.desc}</span>
          )}
        </Label>
      </div>
    ))}
  </RadioGroup>
);

export default RadioStep;